const base = ''
const receptionRouter = [
  {
     name:"登陆",
     path:'/login',
     url:'/Login/login'
  },
  {
     name:"登陆",
     path:'/ZClogin',
     url:'/Login/ZClogin'
  },
  {
    name: '中山市讯华软件有限公司',
    path: '/',
    url: '/Home/home'
  },
  {
    name: "公司概述",
    path: '/detail',
    url: '/Home/HomeDetail/HomeDetail'
  },
  {
    name: "资料下载",
    path: '/Download',
    url: '/Download/Download',
  },
  {
    name: "新速云批发版手机端",
    path: '/AppModile',
    url: '/AppDownload/AppModile',
  },
	{
	  name: "新速云收单易",
	  path: '/AppDownload',
	  url: '/AppDownload/AppDownload',
	},
	{
	  name: "讯联VPN",
	  path: '/AppVpn',
	  url: '/AppDownload/AppVpn',
	},
  {
    name: "收单易",
    path: '/mallQuery',
    url: '/Download/mallQuery',
  },
  {
    name:"APP下载",
    path:'/AppNewDown',
    path:'/AppDownloadList/AppNewDown',
  },
  {
    name: "公司产品",
    path: '/companyProducts',
    url: '/companyProducts/companyProducts',
  },
  {
    name: "产品明细",
    path: '/companyProducts/companyProductsDetail',
    url: '/companyProducts/companyPda/companyProductsDetail',
  },
  {
    name: "安卓软件查询",
    path: '/AndroidList',
    url: '/AndroidList/AndroidList',
  },
  {
    name: "伙伴专区",
    path: '/Partner',
    url: '/Partner/Partner',
  },
  {
    name: "伙伴专区",
    path: '/tempPartner',
    url: '/Partner/tempPartner',
  },
  {
    name: "注册-授权查询管理登陆",
    path: '/tempZC',
    url: '/ProReg/tempZC',
  },
  {
    name: "资质荣誉",
    path: '/QualificationHonor',
    url: '/QualificationHonor/QualificationHonor',
  },
  {
    name: "新速云功能架构测试内容",
    path: '/testProject',
    url: '/MajorProject/testProject',
  },
  {
    name: "新速云功能架构",
    path: '/newProject',
    url: '/MajorProject/newProject',
  },
  {
    name: "新速云介绍",
    path: '/MajorProject',
    url: '/MajorProject/MajorProject',
  },
  {
    name: "飞鱼介绍",
    path: '/FlyingInfo',
    url: '/MajorProject/FlyingInfo',
  },
  {
    name: "数据交互工具介绍",
    path: '/dataMangerSearch',
    url: '/MajorProject/dataMangerSearch',
  },
  {
    name: "讯华小商城介绍",
    path: '/SySmartShopMall',
    url: '/MajorProject/SySmartShopMall',
  },
  {
    name: "讯华收单易介绍",
    path: '/SmAllOrderInfo',
    url: '/MajorProject/SmAllOrderInfo',
  },
  {
    name: "PDA扫码支付",
    path: '/PDAVideoPlayback',
    url: '/PDAVideoPlayback/PDAVideoPlayback',
  },

  {
    name: "酒水行业订货及收款应用",
    path: '/ClassIc',
    url: '/MajorProject/ClassIc',
  },
  {
    name: "供应链数据共享系统",
    path: '/SupplyDataSystem',
    url: '/MajorProject/SupplyDataSystem',
  },
  {
    name: "供应链数据共享系统下载",
    path: '/SupplyDataSystemDown',
    url: '/Download/SupplyDataSystemDown',
  },
  {
    name: "拣货系统下载",
    path: '/PickingSystem',
    url: '/Download/PickingSystem',
  },
  {
    name: "关于WIFI网络一些问题的解决方案",
    path: '/Troubleshooting',
    url: '/Troubleshooting/Troubleshooting',
  },
  {
    name: "应该如何选择合适好用的无线路由器",
    path: '/selWIFI',
    url: '/Troubleshooting/selWIFI',
  },
  {
    name: "验证服务器连接信息工具操作说明",
    path: '/verifyServerConnection',
    url: '/Troubleshooting/verifyServerConnection',
  },
  {
    name: "App使用说明",
    path: '/AppInstructions',
    url: '/Troubleshooting/AppInstructions',
  },
  {
    name: "App使用技巧",
    path: '/AppSkills',
    url: '/Troubleshooting/AppSkills',
  },
  {
    name: "APP新版UI界面",
    path: '/AppNewUi',
    url: '/AppNewUi/AppNewUi',
  },
  {
    name: "二级路由器桥接的正确方式",
    path: '/routeConnect',
    url: '/Troubleshooting/routeConnect',
  },
  {
    name: "PDA的WIFI如何开启无缝漫游功能",
    path: '/PDAWIFI',
    url: '/Troubleshooting/PDAWIFI',
  },
  {
    name: "PDA新增电子传秤技术",
    path: '/PDACall',
    url: '/Troubleshooting/PDACall',
  },
  {
    name: "PDA新增拣货功能",
    path: '/PDAPicking',
    url: '/Troubleshooting/PDAPicking',
  },
  {
    name: "PDA快速盘点功能调查问卷",
    path: '/PDAInventory',
    url: '/Troubleshooting/PDAInventory',
  },
  {
    name: "新速云财务系统",
    path: '/FinancialSystem',
    url: '/Troubleshooting/FinancialSystem',
  },
  {
    name: "新速云简帐固定资产介绍",
    path: '/FixedAssets',
    url: '/Troubleshooting/FixedAssets',
  },
  {
    name: "PDA新增分拣出库功能（包含装箱）",
    path: '/PDASortingWarehousing',
    url: '/Troubleshooting/PDASortingWarehousing',
  },
  {
    name: "讯联VPN连接方法",
    path: '/xunlian',
    url: '/Troubleshooting/xunlian',
  },
  {
    name: "T+企业授权绑定",
    path: '/Tbind',
    url: '/Troubleshooting/Tbind',
  },
  {
    name: "定制项目涉及范围",
    path: '/CustomScope',
    url: '/Troubleshooting/CustomScope',
  },
  {
    name: "手机App下载工具",
    path: '/AppPhone',
    url: '/Troubleshooting/AppPhone',
  },
  {
    name: "授权码",
    path: '/empower',
    url: '/ProReg/empower',
  },
  {
    name: "注册",
    path: '/ZC',
    url: '/ProReg/ZC',
  },
  {
    name: "已申请速云",
    path: '/YSQ',
    url: '/ProReg/YSQ',
  },
  {
    name: "讯联账号查询",
    path: '/FYSS',
    url: '/ProReg/FYSS',
  },
  {
    name: "接口状态管理",
    path: '/ISM',
    url: '/ProReg/ISM',
  },
  {
    name: "绑定域名",
    path: '/BDYM',
    url: '/ProReg/BDYM',
  },
  {
    name: "密码修改",
    path: '/XGMM',
    url: '/ProReg/XGMM',
  },
  {
    name: "供应链绑定域名",
    path: '/GYSBDYM',
    url: '/ProReg/GYSBDYM',
  },
  {
    name: "查询特约商户对账单",
    path: '/CXTYSHDZD',
    url: '/ProReg/CXTYSHDZD',
  },

  {
    name: "",
    path: '/Location',
    url: '/Location/Location',
  },
  {
    name: "",
    path: '/AppExtension',
    url: '/Location/AppExtension',
  },
  {
    name: "",
    path: '/XSYXZ',
    url: '/AppDownload/AppExtension',
  },
  {
    name: "",
    path: '/TestLocation',
    url: '/Location/TestLocation',
  },
  {
    name: "",
    path: '/ScanQRCode',
    url: '/Location/ScanQRCode',
  },
  {
    name: "",
    path: '/Replace',
    url: '/Location/Replace',
  },
  {
    name: "",
    path: '/GetOpenidAndLocation',
    url: '/GetOpenidAndLocation/GetOpenidAndLocation',
  },
  {
    name: "",
    path: '/testDa',
    url: '/Troubleshooting/test',
  },
]
export {
  base,
  receptionRouter
}



// WEBPACK FOOTER //
// ./src/router/receptionRouter.js